var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g2, _g3, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_11270_24088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.19517 7.1531C12.9785 4.07628 19.3505 5.45971 22.4273 10.2431L33.5018 27.46C35.892 31.1759 34.8173 36.1259 31.1014 38.5161L28.2548 40.3472C24.5389 42.7374 19.5889 41.6627 17.1987 37.9467L5.46873 19.7108C2.75389 15.4902 3.97456 9.86794 8.19517 7.1531Z",
    fill: "#B6B9BE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7714 27.539C17.7448 35.4946 20.7679 40.3398 22.3771 41.6562C22.7271 41.9431 23.2347 42.0277 23.8254 41.9787C23.8615 41.8336 23.9551 41.6828 24.151 41.5568C24.7819 41.151 25.3465 41.3522 25.969 40.788C26.4067 40.395 26.8212 40.7206 27.0334 40.9499C27.3682 40.7938 27.694 40.6294 28.005 40.4643C28.0131 40.3371 28.0819 40.2093 28.1989 40.134L32.287 37.5044C32.4066 37.4275 32.5473 37.4171 32.6664 37.4624C33.0385 37.1743 33.4231 36.8607 33.7956 36.534C33.6826 36.2409 33.6 35.7715 34.1096 35.5517C34.8795 35.2167 34.9322 34.622 35.5631 34.2162C35.675 34.1442 35.7834 34.1058 35.8793 34.0928C36.0935 33.6485 36.184 33.2245 36.0829 32.8437C35.5523 30.8335 32.3969 26.0734 27.2199 18.2487C26.2511 16.7816 23.1592 10.2807 20.2455 6.75174C19.1437 5.41902 18.3887 4.84911 17.511 4.56367C17.3344 4.73647 17.0918 4.84024 16.8247 4.82745L14.2499 4.71046C13.9786 4.69685 13.7383 4.56926 13.5755 4.3778C13.4726 4.40223 13.3686 4.43076 13.2663 4.46176L14.2886 6.05113L7.03589 10.7163L6.01355 9.12697C5.9445 9.20971 5.87544 9.29245 5.80892 9.37356C5.91725 9.60347 5.93371 9.87507 5.832 10.1251L4.87075 12.5166C4.77159 12.765 4.57659 12.9427 4.34613 13.0317C4.24189 13.9488 4.44741 14.8722 5.20325 16.4274C7.2037 20.5439 11.8398 26.0515 12.773 27.5415L12.7714 27.539Z",
    fill: "url(#paint0_radial_11270_24088)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2862 6.04649L13.2654 4.45958C10.7962 5.1665 7.67988 7.17102 6.01267 9.1248L7.03501 10.7142L14.2878 6.04895L14.2862 6.04649Z",
    fill: "#3E5270"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0842 27.0742C17.8751 34.7292 20.785 39.3929 22.3215 40.6689C24.0938 42.1382 29.885 38.2703 29.885 38.2703C29.885 38.2703 35.8061 34.6045 35.204 32.3825C34.6825 30.4535 31.6454 25.8717 26.6637 18.3394C25.7298 16.9266 22.7405 10.6802 19.9441 7.27776C18.122 5.06015 17.2964 5.0234 15.1821 4.79483C12.3134 4.48369 6.42162 8.27346 5.51516 11.0129C4.8464 13.0317 4.53746 13.7982 5.79985 16.3758C7.73636 20.3313 12.1808 25.6418 13.0791 27.0775L13.0842 27.0742Z",
    fill: "url(#paint1_radial_11270_24088)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.514 21.9951C16.6874 20.979 19.6231 19.0907 21.0343 18.4442C22.669 17.6924 23.933 17.5551 23.933 17.5551L23.6895 16.9697C23.2767 17.0437 22.1924 17.2813 20.8585 17.9024C19.3888 18.5865 16.3208 20.56 15.0888 21.6137C13.9704 22.5699 13.3045 23.4581 13.0661 23.8031L13.4978 24.2674C13.4978 24.2674 14.151 23.1749 15.5089 21.9984L15.514 21.9951Z",
    fill: "#2A313C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4785 19.9487L9.4896 19.9659C9.51486 19.8487 9.5996 19.6897 9.75018 19.4709C10.0975 18.9653 10.7103 18.1008 11.8292 16.9944C13.4343 15.4081 15.9019 13.8208 18.0135 13.0164C19.4843 12.4571 20.5251 12.2579 21.1292 12.1515C21.3933 12.1036 21.5731 12.0924 21.6852 12.1213L21.6741 12.1041C21.6741 12.1041 21.5216 11.6657 21.4006 11.6007C21.2952 11.543 21.0989 11.5509 20.7805 11.6094C20.1764 11.7158 19.1356 11.9149 17.6648 12.4743C15.5557 13.2771 13.0881 14.8643 11.4805 16.4523C10.3616 17.5587 9.7488 18.4232 9.40147 18.9288C9.21778 19.1967 9.13017 19.368 9.13635 19.4895C9.14537 19.6265 9.47596 19.9503 9.47596 19.9503L9.4785 19.9487Z",
    fill: "#2A313C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0944 21.611C16.3264 20.5573 19.3943 18.5839 20.864 17.8998C22.198 17.2786 23.2823 17.041 23.6951 16.9671L21.6868 12.1172C21.5747 12.0883 21.3949 12.0994 21.1308 12.1474C20.5267 12.2538 19.4859 12.4529 18.0151 13.0123C15.9061 13.815 13.4384 15.4023 11.8308 16.9902C10.7119 18.0967 10.0991 18.9611 9.7518 19.4667C9.59867 19.6871 9.51393 19.8462 9.49376 19.9602L13.0742 23.7988C13.3101 23.4555 13.9786 22.5657 15.097 21.6094L15.0944 21.611Z",
    fill: "url(#paint2_linear_11270_24088)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1684 39.0675C23.1684 39.0675 24.5005 38.8517 26.1583 38.1581C27.4347 37.6263 30.3144 35.7739 31.3276 34.833C32.6462 33.6121 33.395 32.4894 33.395 32.4894C33.395 32.4894 32.4839 30.6648 30.9506 29.1254C30.7952 28.9676 30.6321 28.8147 30.4614 28.6667C30.4614 28.6667 30.4066 28.7437 30.2994 28.8789C29.8659 29.4295 28.5357 30.9679 26.1648 32.493C23.5776 34.1571 21.8092 34.6397 21.1669 34.7706C20.9922 34.8064 20.9013 34.8161 20.9013 34.8161C20.9683 35.0377 21.0446 35.2569 21.1243 35.4704C21.8897 37.4933 23.1617 39.0684 23.1617 39.0684L23.1684 39.0675ZM26.4282 32.8913C28.5931 31.4988 30.0116 30.137 30.7441 29.3523C31.9957 30.7837 32.7482 32.261 32.7482 32.261C32.7482 32.261 32.0706 33.3379 30.8563 34.4917C29.9219 35.3819 27.2457 37.1033 26.0483 37.5844C24.4948 38.2109 23.2339 38.381 23.2339 38.381C23.2339 38.381 22.2111 37.0984 21.4314 35.3774C22.389 35.0714 24.1056 34.3853 26.4282 32.8913Z",
    fill: "url(#paint3_linear_11270_24088)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2352 38.3834C23.2352 38.3834 24.4961 38.2134 26.0496 37.5869C27.2471 37.1058 29.9233 35.3843 30.8577 34.4942C32.072 33.3404 32.7495 32.2635 32.7495 32.2635C32.7495 32.2635 31.9971 30.7862 30.7455 29.3548C30.0156 30.1378 28.5945 31.5013 26.4296 32.8938C24.1044 34.3894 22.3904 35.0739 21.4327 35.3799C22.215 37.0993 23.2352 38.3834 23.2352 38.3834Z",
    fill: "url(#paint4_linear_11270_24088)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1699 22.2496L27.984 21.2452C27.718 20.9042 27.2249 20.2215 26.5503 19.1784C25.8424 18.0835 24.8982 16.2801 24.156 15.0087C22.984 12.9966 22.0194 11.6871 22.0194 11.6871L24.4544 17.6421L27.1642 22.2463L27.1699 22.2496Z",
    fill: "#2A313C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.099 23.4115C11.9481 24.6141 13.196 26.2186 13.9003 27.3193C14.5683 28.3633 14.9964 29.1016 15.1865 29.481L16.4381 29.1567L13.3721 24.7815L8.963 20.0964C8.963 20.0964 9.75461 21.5171 11.0996 23.418L11.099 23.4115Z",
    fill: "#2A313C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.073 27.5134C32.0926 28.0977 32.4928 28.1886 32.4928 28.1886C32.4928 28.1886 29.3019 22.9707 28.2814 21.6414L27.4893 22.764L29.7854 26.5963C29.7854 26.5963 30.179 27.0014 31.0746 27.5158L31.073 27.5134Z",
    fill: "#2A313C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6324 36.4606C19.6324 36.4606 19.7156 36.0587 19.6067 34.8886C19.5116 33.8628 19.3045 33.3341 19.3045 33.3341L16.7694 29.6557L15.4194 29.9109C16.2075 31.3932 19.6308 36.4581 19.6308 36.4581L19.6324 36.4606Z",
    fill: "#2A313C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.251 4.70766L16.8258 4.82465C17.093 4.83743 17.3355 4.73367 17.5121 4.56087C16.8795 4.35463 16.18 4.29596 15.2439 4.20486C14.7601 4.15723 14.1913 4.22349 13.5767 4.375C13.741 4.56892 13.9813 4.69651 14.251 4.70766Z",
    fill: "url(#paint5_radial_11270_24088)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86933 12.5153L5.83059 10.1238C5.93071 9.87129 5.91425 9.59969 5.80751 9.37224C5.41476 9.86872 5.11861 10.3588 4.96133 10.8188C4.65348 11.7101 4.41936 12.3693 4.34471 13.0304C4.57517 12.9414 4.77018 12.7637 4.86933 12.5153Z",
    fill: "url(#paint6_radial_11270_24088)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_11270_24088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8826 34.0914C35.7841 34.106 35.6782 34.1427 35.5663 34.2147C34.9354 34.6206 34.8869 35.2161 34.1128 35.5503C33.6032 35.7701 33.6858 36.2395 33.7988 36.5326C34.6806 35.7564 35.4903 34.8906 35.881 34.089L35.8826 34.0914Z",
    fill: "#C71F1F"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_11270_24088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9693 40.7877C25.3452 41.3494 24.7822 41.1507 24.1513 41.5565C23.9554 41.6825 23.8618 41.8333 23.8257 41.9784C24.7764 41.8964 25.9458 41.4612 27.0337 40.9496C26.824 40.7187 26.407 40.3947 25.9693 40.7877Z",
    fill: "#C71F1F"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.075 8.97837C16.7434 9.65971 19.299 11.0049 19.299 11.0049C19.299 11.0049 17.0041 9.32133 16.3303 8.65393C15.8338 8.1616 14.5676 6.47827 14.5676 6.47827C14.5676 6.47827 15.5636 8.4573 16.075 8.97837Z",
    fill: "#6BA6FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45401 17.338C9.45401 17.338 9.28971 14.4547 8.9469 13.5639C8.68481 12.8824 7.29699 11.1554 7.29699 11.1554C7.29699 11.1554 8.30371 13.0057 8.54583 13.6616C8.87371 14.5516 9.45401 17.338 9.45401 17.338Z",
    fill: "#6BA6FF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M15.0939 21.61C16.0689 20.7773 18.1918 19.37 19.7619 18.4785C18.459 17.8395 15.3225 16.3629 13.1425 15.8421C12.6654 16.2187 12.223 16.6043 11.8294 16.9933C10.7105 18.0997 10.0977 18.9642 9.75036 19.4698C9.59723 19.6902 9.5125 19.8492 9.49232 19.9632L13.0728 23.8019C13.3087 23.4585 13.9771 22.5687 15.0955 21.6125L15.0939 21.61Z",
    fill: "url(#paint7_linear_11270_24088)"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1605 32.2961L26.4122 31.4911C27.8586 30.4074 30.0736 28.6064 29.8844 27.8816C29.6069 26.8129 23.934 17.8928 23.934 17.8928C23.934 17.8928 22.2325 18.0432 18.501 20.5618C14.6592 22.9146 13.8193 24.3989 13.8193 24.3989C13.8193 24.3989 19.5838 33.2601 20.4413 33.9557C21.0223 34.4285 23.5797 33.1597 25.1656 32.2929L25.1605 32.2961Z",
    fill: "url(#paint8_linear_11270_24088)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0375 38.4007C29.2331 38.2853 29.4535 38.1471 29.7028 37.9867C29.7028 37.9867 30.1677 37.6807 30.3553 37.553C33.9625 35.076 34.9408 33.0185 34.9408 33.0185L33.6664 32.6363C32.1696 35.3583 29.0656 36.9961 29.0656 36.9961C29.0656 36.9961 26.2855 39.1432 23.1905 39.3748L23.0097 40.6929C23.0097 40.6929 25.2877 40.6559 29.0375 38.4007Z",
    fill: "#C71F1F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9337 10.633C21.9337 10.633 21.1483 9.33365 19.2722 6.95924C17.436 4.63576 14.436 4.9873 14.436 4.9873C17.2552 5.07601 21.9322 10.6305 21.9322 10.6305L21.9337 10.633Z",
    fill: "#E7F1FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02369 19.5818C8.02369 19.5818 4.90711 13.0201 5.99701 10.4204C5.99701 10.4204 4.43566 13.0029 5.78598 15.6389C7.16862 18.3307 8.02527 19.5843 8.02527 19.5843L8.02369 19.5818Z",
    fill: "#E7F1FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1565 21.8514C9.76349 21.2124 9.39209 20.5456 9.2182 20.3926C9.2182 20.3926 8.70092 20.8856 9.00108 21.3858C9.30378 21.8844 10.547 22.4921 10.1565 21.8514Z",
    fill: "#1D222A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98415 23.0934L9.36779 21.4927C9.23044 21.3407 9.02002 21.1869 8.83257 21.4155C8.83257 21.4155 7.87184 22.5386 7.85146 22.7921C7.83888 22.9291 7.91467 23.0301 7.98415 23.0934Z",
    fill: "url(#paint9_linear_11270_24088)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51761 21.6915C9.51761 21.6915 9.4593 21.5897 9.37017 21.4902L7.98399 23.0925C8.04301 23.1451 8.09856 23.1756 8.09856 23.1756L9.51507 21.6931L9.51761 21.6915Z",
    fill: "#1D222A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1137 13.4697C23.5331 14.0882 23.538 12.6812 23.2073 12.2006C22.8766 11.7201 22.1754 12.0109 22.1754 12.0109C22.2414 12.2366 22.6942 12.8511 23.1137 13.4697Z",
    fill: "#1D222A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1509 12.0341C25.1256 11.9389 25.0664 11.8132 24.9225 11.7629C24.6834 11.6764 23.263 12.0849 23.263 12.0849C22.9681 12.1631 23.0344 12.434 23.1215 12.6253L25.1525 12.0366L25.1509 12.0341Z",
    fill: "url(#paint10_linear_11270_24088)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2326 12.8216L25.169 12.1473C25.169 12.1473 25.1672 12.0997 25.1501 12.0341L23.1191 12.6228C23.1705 12.7361 23.231 12.8191 23.231 12.8191L23.2326 12.8216Z",
    fill: "#1D222A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1249 19.3423L27.3134 18.0806C27.2595 17.9968 27.1439 17.9737 27.0574 18.0293L28.0654 19.5965C28.1519 19.5409 28.1788 19.426 28.1249 19.3423Z",
    fill: "#592300"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M32.268 25.6098L31.4564 24.3482C31.4025 24.2644 31.2869 24.2412 31.2004 24.2969L32.2085 25.8641C32.295 25.8084 32.3219 25.6936 32.268 25.6098Z",
    fill: "#592300"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3952 28.8168C13.449 28.9005 13.5647 28.9237 13.6511 28.8681L12.6431 27.3009C12.5566 27.3565 12.5297 27.4713 12.5836 27.5551L13.3952 28.8168Z",
    fill: "#592300"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3807 35.1859C17.4346 35.2697 17.5503 35.2929 17.6367 35.2372L16.6287 33.67C16.5422 33.7257 16.5153 33.8405 16.5692 33.9243L17.3807 35.1859Z",
    fill: "#592300"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7667 11.7344C17.0313 11.5921 17.2472 11.6483 17.5143 11.5044C17.5347 11.4913 17.5429 11.4651 17.5303 11.4453C17.5176 11.4256 17.4887 11.4198 17.4683 11.4329C17.2038 11.5752 16.9878 11.519 16.7208 11.663C16.7004 11.676 16.6921 11.7023 16.7048 11.722C16.7175 11.7417 16.7448 11.745 16.7667 11.7344Z",
    fill: "#0065FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8601 11.8796C17.1247 11.7373 17.3406 11.7935 17.6077 11.6496C17.6281 11.6365 17.6364 11.6102 17.6237 11.5905C17.611 11.5708 17.5821 11.565 17.5617 11.5781C17.2972 11.7204 17.0813 11.6642 16.8167 11.8065C16.7964 11.8196 16.7881 11.8458 16.8008 11.8656C16.8134 11.8853 16.8423 11.8911 16.8627 11.878L16.8601 11.8796Z",
    fill: "#0065FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9524 12.0232C17.217 11.8809 17.4329 11.9371 17.7 11.7931C17.7203 11.78 17.7286 11.7538 17.716 11.7341C17.7033 11.7144 17.6744 11.7086 17.654 11.7217C17.3895 11.864 17.1735 11.8078 16.909 11.9501C16.8887 11.9632 16.8804 11.9894 16.893 12.0091C16.9057 12.0288 16.9346 12.0346 16.955 12.0215L16.9524 12.0232Z",
    fill: "#0065FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6703 15.9062C10.9095 15.7245 10.9479 15.5047 11.1896 15.3213C11.21 15.3083 11.2167 15.2795 11.204 15.2598C11.1913 15.2401 11.1624 15.2343 11.1437 15.2499C10.9045 15.4316 10.8661 15.6514 10.6244 15.8347C10.604 15.8478 10.5973 15.8765 10.61 15.8963C10.6227 15.916 10.6516 15.9218 10.6703 15.9062Z",
    fill: "#0065FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7636 16.0507C11.0028 15.869 11.0412 15.6492 11.2804 15.4675C11.3007 15.4544 11.3074 15.4257 11.2947 15.406C11.2821 15.3863 11.2532 15.3805 11.2344 15.396C10.9952 15.5778 10.9568 15.7976 10.7176 15.9793C10.6973 15.9924 10.6906 16.0211 10.7032 16.0408C10.7159 16.0605 10.7448 16.0663 10.7636 16.0507Z",
    fill: "#0065FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M10.856 16.195C11.0952 16.0132 11.1336 15.7934 11.3753 15.6101C11.3957 15.597 11.4024 15.5683 11.3897 15.5486C11.377 15.5289 11.3481 15.5231 11.3294 15.5386C11.0902 15.7203 11.0518 15.9401 10.8126 16.1219C10.7922 16.1349 10.7855 16.1637 10.7982 16.1834C10.8109 16.2031 10.8398 16.2089 10.8586 16.1933L10.856 16.195Z",
    fill: "#0065FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3966 39.0586C30.3966 39.0586 31.4609 38.3984 32.6717 37.4628C32.5526 37.4175 32.4119 37.4279 32.2923 37.5048L28.2042 40.1344C28.0846 40.2113 28.0168 40.3351 28.0103 40.4647C29.3612 39.7525 30.4007 39.0595 30.4007 39.0595L30.3966 39.0586Z",
    fill: "url(#paint11_linear_11270_24088)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M23.2356 38.3837C23.2356 38.3837 24.4965 38.2137 26.05 37.5872C27.2475 37.1061 29.9237 35.3846 30.858 34.4945C31.2802 34.094 31.6356 33.7017 31.923 33.3601C31.4336 33.013 29.4517 31.7099 27.7446 31.9858C27.3423 32.2829 26.9041 32.5856 26.4284 32.8916C24.1032 34.3873 22.3892 35.0717 21.4315 35.3777C22.2138 37.0971 23.234 38.3812 23.234 38.3812L23.2356 38.3837Z",
    fill: "url(#paint12_linear_11270_24088)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11270_24088",
    x: 3.02319,
    y: 4.51465,
    width: 32.7512,
    height: 38.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_11270_24088"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_11270_24088",
    x: 33.5136,
    y: 33.8889,
    width: 2.56895,
    height: 2.84336,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_11270_24088"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_11270_24088",
    x: 23.6257,
    y: 40.4035,
    width: 3.60801,
    height: 1.775,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_11270_24088"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11270_24088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.2331 23.1941) rotate(-168.663) scale(21.5586 21.5477)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78A2E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_11270_24088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.0782 23.0239) rotate(-168.663) scale(21.8206 21.8096)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11270_24088",
    x1: 23.1877,
    y1: 19.1244,
    x2: 10.3872,
    y2: 16.1309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D4E67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050B14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11270_24088",
    x1: 32.7946,
    y1: 35.0647,
    x2: 21.4663,
    y2: 32.4156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11270_24088",
    x1: 32.1304,
    y1: 34.8982,
    x2: 22.0917,
    y2: 32.5506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00163B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C1C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_11270_24088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5245 4.55181) rotate(-168.663) scale(1.4025 1.40179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80A9E5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_11270_24088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.15961 11.2187) rotate(-168.663) scale(1.4025 1.40179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80A8E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11270_24088",
    x1: 16.7824,
    y1: 21.5607,
    x2: 13.9869,
    y2: 18.4632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E5270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_11270_24088",
    x1: 24.6998,
    y1: 32.5925,
    x2: 17.9135,
    y2: 20.8176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04162F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40516B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_11270_24088",
    x1: 9.18198,
    y1: 22.3261,
    x2: 8.02277,
    y2: 22.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FC5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_11270_24088",
    x1: 25.0647,
    y1: 12.4033,
    x2: 23.1172,
    y2: 11.9478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_11270_24088",
    x1: 32.2299,
    y1: 39.34,
    x2: 28.4682,
    y2: 38.4604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00163B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_11270_24088",
    x1: 28.5619,
    y1: 39.416,
    x2: 27.1558,
    y2: 35.7983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00163B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarMarker);
export default __webpack_public_path__ + "static/media/carMarker.fced0dad61d80976011601b0a2302bbf.svg";
export { ForwardRef as ReactComponent };